import { TRIP } from '@pibex/shared';

const LOCALE = 'es-AR';

/** Parses a `YYYY-MM-DD` date as a local calendar date (avoids UTC off-by-one). */
function parseDay(iso: string): Date {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y ?? 1970, (m ?? 1) - 1, d ?? 1);
}

/** "Bariloche" — the city without the country suffix. */
export const tripPlace: string = TRIP.destination.split(',')[0]?.trim() ?? TRIP.destination;

/** "24–31 de octubre, 2026" (same month assumed by the trip facts; falls back to a full range). */
export function formatTripDates(): string {
  const start = parseDay(TRIP.startDate);
  const end = parseDay(TRIP.endDate);
  const month = new Intl.DateTimeFormat(LOCALE, { month: 'long' });
  if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
    return `${start.getDate()}–${end.getDate()} de ${month.format(start)}, ${start.getFullYear()}`;
  }
  return `${start.getDate()} de ${month.format(start)} – ${end.getDate()} de ${month.format(end)}, ${end.getFullYear()}`;
}

export const tripDates: string = formatTripDates();

/** "Bariloche · 24–31 de octubre, 2026" */
export const tripTitle: string = `${tripPlace} · ${tripDates}`;

const dateTime = new Intl.DateTimeFormat(LOCALE, { dateStyle: 'short', timeStyle: 'short' });

/** Short local date-time for timestamps coming from the api (ISO strings). */
export function formatDateTime(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : dateTime.format(date);
}

/** First name for greetings; falls back to the email's local part. */
export function firstName(name: string | null, email: string): string {
  const trimmed = name?.trim();
  if (trimmed) return trimmed.split(/\s+/)[0] ?? trimmed;
  return email.split('@')[0] ?? email;
}
